import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import plCommon from "./locales/pl/common.json";
import enCommon from "./locales/en/common.json";
import plCruises from "./locales/pl/cruises.json";
import enCruises from "./locales/en/cruises.json";
import plBikesDescription from "./locales/pl/bikesDescription.json";
import enBikesDescription from "./locales/en/bikesDescription.json";
import plAddress from "./locales/pl/address.json";
import enAddress from "./locales/en/address.json";
import plBikes from "./locales/pl/bikes.json";
import enBikes from "./locales/en/bikes.json";
import plPriceList from "./locales/pl/priceList.json";
import enPriceList from "./locales/en/priceList.json";
import plHouses from "./locales/pl/houses.json";
import enHouses from "./locales/en/houses.json";
import plPolicy from "./locales/pl/policy.json";
import enPolicy from "./locales/en/policy.json";
import plBoats from "./locales/pl/boats.json";
import enBoats from "./locales/en/boats.json";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: "pl",
        interpolation: { escapeValue: false },
        ns: ["common", "cruises", "bikes", "bikesDescription", "address", "priceList", "houses", "policy", "boats"],
        defaultNS: "common",
        resources: {
            pl: {
                common: plCommon,
                cruises: plCruises,
                bikes: plBikes,
                bikesDescription: plBikesDescription,
                address: plAddress,
                priceList: plPriceList,
                houses: plHouses,
                policy: plPolicy,
                boats: plBoats
            },
            en: {
                common: enCommon,
                cruises: enCruises,
                bikes: enBikes,
                bikesDescription: enBikesDescription,
                address: enAddress,
                priceList: enPriceList,
                houses: enHouses,
                policy: enPolicy,
                boats: enBoats
            }
        },
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"]
        }
    });

export default i18n;